
























import { createComponent, ref, watch, computed } from '@vue/composition-api';
import UIInput from '@sbvr/lbe-ui/UIInput.vue';
import UIButton from '@sbvr/lbe-ui/UIButton.vue';
import BaseLayout from './layouts/BaseLayout.vue';
import UICheckbox from '@sbvr/lbe-ui/UICheckbox.vue';
import { passwordResetRequest } from '@/core/actions/login';
import { useLocalProp } from '@sbvr/lbe-composition-helpers';
import useFlash from '@sbvr/lbe-web-panel/flash';
import isEmail from 'validator/es/lib/isEmail';

export default createComponent({
  name: 'PasswordResetRoute',
  components: {
    UIInput,
    UIButton,
    UICheckbox,
    BaseLayout,
  },
  props: {
    email: {
      type: String,
      required: true,
    },
  },
  setup (props, { emit }) {
    const localEmail = useLocalProp({ props, emit }, 'email');
    const hasSent = ref(false);
    const { showFlash } = useFlash();
    watch(() => localEmail.value, () => {
      hasSent.value = false;
    });
    const valid = computed(() => {
      return isEmail(localEmail.value);
    });
    async function onRequestLink () {
      hasSent.value = true;
      try {
        await passwordResetRequest(localEmail.value);
        showFlash({
          type: 'success',
          message: `An email was sent to ${localEmail.value}, click on the link you recieve to finalize your password reset.`,
        });
      } catch {
        showFlash({
          type: 'error',
          message: 'Error',
        });
        hasSent.value = true;
      }
    }
    return {
      localEmail,
      hasSent,
      valid,
      onRequestLink,
    };
  },
});
